import React from 'react';
import { getPointsReport } from '@/api/reports';
import SalesFilters from 'src/pages/User/Reports/components/SalesFilters';

const PointsFilters = () => {
  return <SalesFilters getDataMethod={getPointsReport} />;
};

export default PointsFilters;
